'use client'

import { useEffect } from "react"

export default function FacebookSDK(props) {
  
  useEffect(() => {
    window.fbAsyncInit = function() {
      FB.init({
        appId      : props.site?.api_keys?.facebook_app_id,
        cookie     : true,
        xfbml      : true,
        version    : 'v10.0'
      });
    };
  }, [])
  
  return <>
  </>
  
}